module.exports = __webpack_public_path__ + "static/upsell-1-3d1a2b8459f36799fcddb3ca110d20bc.png";